var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about",staticStyle:{"background-color":"aqua","display":"flex"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }